<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkcarin_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/car/parkcarin';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        refreshBtn:false,
        column: [
          {
            label: '',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车场ID',
            prop: 'parkingLotId',
            rules: [
              {
                required: true,
                message: '请输入停车场ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域ID',
            prop: 'regionId',
            rules: [
              {
                required: true,
                message: '请输入区域ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'regionName',
            rules: [
              {
                required: true,
                message: '请输入区域名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '进入通道ID',
            prop: 'inPassageId',
            rules: [
              {
                required: true,
                message: '请输入进入通道ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '通道名称',
            prop: 'inPassageName',
            rules: [
              {
                required: true,
                message: '请输入通道名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆识别时间',
            prop: 'inIdentifyTime',
            rules: [
              {
                required: true,
                message: '请输入车辆识别时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆识别照片',
            prop: 'inIdentifyImage',
            rules: [
              {
                required: true,
                message: '请输入车辆识别照片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号码',
            prop: 'plateNumber',
            rules: [
              {
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐编号',
            prop: 'setmealNo',
            rules: [
              {
                required: true,
                message: '请输入套餐编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐名称',
            prop: 'setmealName',
            rules: [
              {
                required: true,
                message: '请输入套餐名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '是否是月卡车: 1是 0不是',
            prop: 'monthCar',
            rules: [
              {
                required: true,
                message: '请输入是否是月卡车: 1是 0不是',
                trigger: 'change',
              },
            ],
          },
          {
            label: '进入时间',
            prop: 'inTime',
            rules: [
              {
                required: true,
                message: '请输入进入时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '进入照片',
            prop: 'inImage',
            rules: [
              {
                required: true,
                message: '请输入进入照片',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            rules: [
              {
                required: true,
                message: '请输入出场时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkcarin_add, false),
        viewBtn: this.vaildData(this.permission.parkcarin_view, false),
        delBtn: this.vaildData(this.permission.parkcarin_delete, false),
        editBtn: this.vaildData(this.permission.parkcarin_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
